import type { ReactNode } from 'react'
import Badge from '@mui/material/Badge'
import { useChatPanelUnread } from './hooks/useChatPanelUnread'
import { chatNavDot } from './toolbarChatBadge'

/**
 * The sidebar Chat item's unread dot. Owns the unread subscription so a count change re-renders
 * only this badge, not the whole (very large) MainMenu.
 */
export function ChatNavDot({ children }: Readonly<{ children: ReactNode }>) {
  const dot = chatNavDot(useChatPanelUnread())
  return (
    <Badge
      color={dot.color}
      variant="dot"
      invisible={!dot.visible}
      data-testid="chat-unread-dot"
      sx={{ '& .MuiBadge-badge': { top: 2, right: 2 } }}
    >
      {children}
    </Badge>
  )
}
